import AvatarGroup from '@mui/material/AvatarGroup';
import Icon from "../Shared/Icon";
import Filters from '../Shared/Filters';

const MatchIcons = props => {
    const typeMap = {
        jobs: {
            system: x => x.StateMachine.split('-').find(y => y != 'sqlserver'),
            icon: x => null
        },
        schemas: {
            system: x => x.SystemKey,
            icon: x => null
        },
        executions: {
            system: x => null,
            icon: x => Filters.Executions.Status.find(y => y.value === x.Status)
        },
        queries: {
            system: x => null,
            icon: x => null
        },
        descriptions: {
            system: x => null,
            icon: x => null
        },
        commits: {
            system: x => null,
            icon: x => null
        },
    }
    const systems = [...new Set(props.matches.map(x => typeMap[props.type].system(x)))]
    const icons = [...new Set(props.matches.map(x => typeMap[props.type].icon(x)))]
    return (
        <AvatarGroup>
            {
                systems.map((x, key) => {
                    return x && <Icon key={key} system={x} />
                })
            }
            {
                icons.map((x, key) => {
                    return x && <Icon key={key} icon={x.icon} color={x.color} />
                })
            }
        </AvatarGroup>
    )
}
export default MatchIcons